import { Button } from 'antd';
import styled from 'styled-components';

export const Content = styled.div`
  padding: 32px 16px 34px;
  max-width: 600px;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  &&& {
    background-color: #35b678;
    width: 100%;
    height: 50px;
    font-weight: 700;
    font-size: 16px;
    :hover {
      background: #35b678;
    }
  }
`;

export const PhoneImage = styled.div`
  margin: 21px 40px 48px;

  img {
    max-width: 250px;
    width: auto;
  }
`;

export const StyledLink = styled.a`
  width: 100%;
`;
